import {
  SET_GALLERY_DATA,
  IS_FETCHING,
  TOGGLE_DISPLAY_ENTRY,
  GALLERY_SUBMISSION_STATUS,
  GALLERY_SUBMISSION_FETCHING,
} from 'js/store/gallery/Gallery.actions.js';

import { parseData } from 'js/store/gallery/Gallery.parser.js';

const initState = {
  hasFetched: false,
  isFetching: false,
  entryIds: [],
  entryById: {},
  displayEntry: false,
  isSubmitting: false,
  submissionStatus: false,
  submissionMessage: '',
};

const gallery = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case GALLERY_SUBMISSION_FETCHING: {
      nextState.isSubmitting = action.payload;
      return { ...state, ...nextState };
    }
    case GALLERY_SUBMISSION_STATUS: {
      const { status, message } = action.payload;
      nextState.submissionStatus = status;
      nextState.submissionMessage = message;
      nextState.isSubmitting = false;
      return { ...state, ...nextState };
    }
    case SET_GALLERY_DATA: {
      const { entryById, entryIds } = parseData(action.payload);
      nextState.entryIds = entryIds;
      nextState.entryById = entryById;
      nextState.hasFetched = true;
      nextState.isFetching = false;
      return { ...state, ...nextState };
    }
    case IS_FETCHING: {
      nextState.isFetching = true;
      return { ...state, ...nextState };
    }
    case TOGGLE_DISPLAY_ENTRY: {
      nextState.displayEntry = action.payload;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default gallery;
